<template>
  <div class="upload">
    <Header />
    <div v-if="!containsSpecialChar" class="upload-scroll">
      <div class="upload-body">
        <div class="title">
          <h2 style="margin-top: 0px">KSSD</h2>
          K-mer substring space decomposition.
        </div>
        <!-- 文件选择区域 -->
        <div class="upload-file" >
          <div style="font-size: 18px" @click="SelectFile">
            <h1 style="margin-top: 10px">Click here</h1>
            <p>
              to choose some fastq or fasta format
              file (.fastq/.fq/.fasta/.fna/.fas/.fa) from your computer.
            </p>
          </div>
          <!-- 文件展示区域 -->
          <div class="upload-files-show" >
            <div class="show-list" :class="{'scroll' : files.length > 0}">
              <div v-for="(file,index) in files" :key="index+file.name" class="show-item">
                <i v-if="!isSubmiting"
                  class="el-icon-error del"
                  style="font-size: 20px"
                  title="delete file"
                  @click="delFile(index)"
                ></i>
<!--                 <i
                  class="el-icon-s-order"
                  style="font-size: 24px"
                  title="file"
                ></i> -->
                <div class="item-right ellipse-line-one">
                  <div class="item-name ellipse-line-one" :title="file.file">{{ file.name }}</div>
                  <div>{{ bytesToSize(file.size) }}</div>
                  <template v-if="isSubmiting && file.state === 0">
                    <div>wait</div>
                  </template>
                  <template v-else-if="isSubmiting && typeof(file.state) != 'undefined'">
                    <i v-if="file.state > 0 && file.state < 9"
                      class="el-icon-loading"
                      style="font-size: 12px"
                      :title="file.showMsg"
                    ></i>
                    <div v-else
                      :title="file.showMsg"
                      :class="{'error' : file.state < 0 }">{{ file.showMsg }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="files.length > 0" class="submit-btns">
              <div class="error" v-if="errorInfo">{{ errorInfo }}</div>
              <el-button type="primary" @click="toSubmit" v-if="!isSubmiting"
                >Submit</el-button>
                <el-button type="warning" @click="toCancel" v-if="isSubmiting"
                >{{ CancelBtName }}</el-button>
            </div>
          </div>
        </div>

        <h2>Samples</h2>
            <div>
      <el-form ref="form" :inline="true">
        <el-form-item label="Keyword：" style="margin-right:20px">
          <el-input v-model="listQuery.keyword" style="width:200px" placeholder="keyword" clearable />
        </el-form-item>
        <el-button type="danger" plain style="" @click="handleFilter">reset</el-button>
        <el-button type="primary" plain style="margin-left:10px" @click="handleSearch">search</el-button>
      </el-form>
    </div>
        <div class="flex" style="padding-right: 10px; margin-bottom: 10px">
          <div style="font-size: 18px" class="flex-1">
            Don't have a result of your own to view? Try one of these!
          </div>
            <el-button
              size="mini"
              type="primary"
              @click="Switch_view"
              >Switch view
            </el-button>
          &nbsp;&nbsp;&nbsp;
          <el-tooltip placement="top" content="Please select at least 3 fastq-format samples">
            <a>
            <el-button
              :disabled="selectionData.length < 3"
              size="mini"
              type="primary"
              @click="Batch_qiime"
              >Qiime view
            </el-button>
            </a>
          </el-tooltip>
          &nbsp;&nbsp;&nbsp;
          <el-button
            :disabled="selectionData.length < 1"
            size="mini"
            type="danger"
            @click="DeleteRecord"
            >Delete
          </el-button>
        </div>
        <div v-show="!isCardListView" class="file-list flex-1">
          <el-table
            ref="multipleTable"
            height="100%"
            stripe
            :data="tableData"
            empty-text="no data"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @select="tableSelect"
            @select-all="tableSelectAll"
          >
            <el-table-column
              type="selection"
              fixed="left"
              :selectable="selectable"
              width="55"> </el-table-column>
            <el-table-column
              type="index"
              label="Idx"
              fixed="left"
              width="50"></el-table-column>
            <el-table-column
              prop="FileName"
              label="Sample file"
              width="200"
              fixed="left"
              :title="SelectFile"
            >
            </el-table-column>
            <el-table-column
              prop="OriginalCreateTime"
              label="Sample create time"
              width="200"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="FileClass"
              label="Class"
              width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="Size" width="100">
              <template slot-scope="scope">{{ bytesToSize(scope.row.FileSize) }}</template>
            </el-table-column>
            <el-table-column label="Handle" width="120">
              <template slot-scope="scope">{{ scope.row.Handle }}</template>
            </el-table-column>
            <!-- <el-table-column label="Spend(s)" width="100">
              <template slot-scope="scope">{{ scope.row.LocalSpend }}</template>
            </el-table-column> -->
            <el-table-column label="Description" width="100" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.Description }}</template>
            </el-table-column>
            <el-table-column label="Attributes" width="200" show-overflow-tooltip>
              <template slot-scope="scope">{{ getTableSystemLabels(scope.row.SystemLabels) }}</template>
            </el-table-column>
            <el-table-column label="Labels" width="180" show-overflow-tooltip>
              <template slot-scope="scope">{{ getTableLabels(scope.row.CustomLabels) }}</template>
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              width="220"
              label="Operate"
            >
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click.stop="editLabels(scope.row, -1)"
                  >Edit labels</el-button>
                <el-button type="success" size="mini" :disabled="isdecomposed(scope.row.Handle)" @click="Detail(scope.$index, scope.row)"
                  >Krona view</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="isCardListView" class="card-list flex-1 flex-column flex-left">
          <div
            v-for="(item,index) in tableData" :key="index+item.FileName"
            class="card-item flex-row flex-center"
            :class="{'selected':selectedIdxs.includes(item.index)}"
            @click="selectClick(index)"
            >
            <el-image
              class="card-img"
              :src="getImgUrl(item.ScreenShot)"
              fit="cover">
              <div slot="error" class="image-slot" style="height: 100%;">
                <div class="screen-shot-tips">No thumbnail</div>
              </div>
            </el-image>
              <div class="card-detail flex-row flex-left" @click="catchTap">
                <div class="card-title ellipse-line-one"><span class="card-big-title">Sample file:</span>{{item.FileName}}</div>
                <div class="card-title ellipse-line-one"><span class="card-big-title">Sample create time:</span>{{item.OriginalCreateTime}}</div>
                <div class="card-title ellipse-line-one"><span class="card-big-title">Class:{{item.FileClass}}</span></div>
                <div class="card-title ellipse-line-one"><span class="card-big-title">Size:</span>{{bytesToSize(item.FileSize)}}</div>
                <div class="card-title ellipse-line-one"><span class="card-big-title">Handle:</span>{{item.Handle}}</div>
                <!-- <div class="card-title ellipse-line-one">spend(s):{{item.LocalSpend}}</div> -->
                <!-- <el-tooltip class="item" effect="dark" :content="item.Description" placement="top-start"> -->
                  <div class="card-title ellipse-line-one"><span class="card-big-title">Description:</span>{{item.Description}}
                    <i class="el-icon-edit card-item-edit" @click="editLabels(item,1)"></i>
                  </div>
                <!-- </el-tooltip> -->
                <!-- <el-tooltip class="item" effect="dark" :content="getTableSystemLabels(item.SystemLabels)" placement="top-start"> -->
                  <div class="card-title ellipse-line-one"><span class="card-big-title">Attributes:</span>{{getTableSystemLabels(item.SystemLabels)}}
                    <i class="el-icon-edit card-item-edit" @click="editLabels(item,2)"></i>
                  </div>
                <!-- </el-tooltip> -->
                <!-- <el-tooltip class="item" effect="dark" :content="getTableLabels(item.CustomLabels)" placement="top-start"> -->
                  <div class="card-title ellipse-line-one"><span class="card-big-title">Labels:</span>{{getTableLabels(item.CustomLabels)}}
                    <i class="el-icon-edit card-item-edit" @click="editLabels(item,3)"></i>
                  </div>
                <!-- </el-tooltip> -->
              </div>

              <div class="card-btns flex-column flex-middle">
                <!-- <el-button type="primary" size="mini" @click.stop="editLabels(item,-1)"
                  >Edit labels</el-button> -->
                <el-button type="success" size="mini" :disabled="isdecomposed(item.Handle)" @click.stop="Detail(item.index, item)"
                  >Krona view</el-button>
              </div>
          </div>
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.pageSize"
          :page-sizes="[12,24,36,48]"
          @pagination="getDecomposList"
        />
        <Footer />
      </div>
    </div>
    <div v-else style="color:red;">The file path where the program is located contains special characters, please change the directory and try again!</div>
<!--     <div v-if="isSubmiting" class="mask"></div> -->
    <LabelsDialog ref="dialog" @updateList="getDecomposList" :sys-labels="sysLabels"  />
    <UploadFilesDialog ref="uploadDialog" @updateSelectedFilesList="updateSelectedFilesList"  />
  </div>
</template>

<script>
import Footer from './common/footer.vue'
import Header from './common/header.vue'
import LabelsDialog from './common/labels_dialog.vue'
import UploadFilesDialog from './common/upload_files_dialog.vue'
import Pagination from './common/Pagination'

import { getOSDetailName, getOSName } from '../utils/common'

export default {
  name: 'index',
  props: {
    msg: String
  },
  components: { Footer, Header, LabelsDialog, UploadFilesDialog, Pagination },
  data () {
    return {
      userID: '',
      form: {
        threadnum: 3,
        maxSelectMultipleFileNum: 100,
        settimeoutTime: 2000,
        selectFileWithWeb: false
      },
      CancelBtName: 'Cancel',
      getDecompos: false,
      list: [],
      time: '', // 定时器
      count: 1,
      charSet: ':0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-+!@#$%^~;.,()[]{}\\\\/`',
      hasScuess: true, // 判断上传状态是否完成
      errorInfo: '', // 错误信息
      downloadInstall: '',
      tableData: [],
      selectionData: [],
      files: [],
      isSubmiting: false,
      isCardListView: true, // 是否是卡片列表形式显示
      selectedIdxs: [], // 选中的索引
      sysLabels: [], // 后台返回的系统标签配置
      listQuery: {
        page: 1,
        pageSize: 12,
        keyword: ''
      },
      total: 0,
      ipGeo: {
        'query': '-1',
        'status': '',
        'country': '',
        'countryCode': '',
        'region': '',
        'regionName': '',
        'city': '',
        'zip': '',
        'lat': -1,
        'lon': -1,
        'timezone': '',
        'isp': '',
        'org': '',
        'as': ''
      },
      OSName: getOSDetailName(),
      containsSpecialChar: false // 程序所在的目录是否含有特殊字符
    }
  },
  watch: {
    selectedIdxs () {
      this.selectionData = this.tableData.filter((item, index) => this.selectedIdxs.includes(index))
    }
  },
  created () {
  },
  mounted () {
    this.getWorkPath()
    document.ondragover = function (e) {
      e.preventDefault()
      return false
    }
    document.ondrop = function (e) {
      e.preventDefault()
      return false
    }
    let commonSetting = localStorage.getItem('commonSetting')
    if (commonSetting) {
      this.form = JSON.parse(commonSetting)
    }
    console.log('getItem form: ', this.form)
    // 每次都获取新的userId
    this.getUserID()
    this.downloadInstall = this.globalUrl + '/downloadInstall'

    window.addEventListener('message', this.handleMessage)
    let self = this
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        // 切离该页面时执行
      } else if (document.visibilityState === 'visible') {
        // 切换到该页面时执行
        self.getDecomposList()
      }
    })
  },
  methods: {
    /**
     * 检查文件名（含路径）是否包含在charSet里
     */
    checkFileName (name) {
      console.log('name:', name)
      for (let i = 0; i < name.length; i++) {
        if (this.charSet.indexOf(name[i]) === -1) {
          console.log('indexOf=-1: ', name[i])
          return false
        }
      }
      return true
    },
    /**
     * 删除选择的文件
     */
    delFile (index) {
      this.files.splice(index, 1)
    },
    bytesToSize (bytes) {
      if (typeof bytes !== 'number') {
        return bytes
      }
      if (bytes === 0) {
        return '0 B'
      }
      let k = 1024
      let sizes = ['B', 'KB', 'MB', 'GB', 'TB']
      let i = Math.floor(Math.log(bytes) / Math.log(k))
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
    },
    isdecomposed (ot) {
      if (ot === 'decomposed') {
        return false
      } else {
        return true
      }
    },
    selectable (row, index) {
      return true
      // return row.FileClass === '.fastq'
      // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    /**
     * 获取userID
     */
    getUserID () {
      console.log('getUserID ...')
      const data = this.axios.get('/whoisi')
      data.then(res => {
        console.log('res: ', res)
        if (res.data.retCode === 0) {
          this.userID = res.data.userID
          localStorage.setItem('userID', this.userID)
          console.log('whoisi get userID:', this.userID)
          if (this.getDecompos === false) {
            this.getLabelsConfig()
            this.getDecomposList()
            this.getDecompos = true
          }
        }
      })
    },
    /**
     * 获取UserIP
     */
    async getUserIP () {
      console.log('getUserIP ...')
      try {
        const res = await this.axios.get('3')
        console.log('ip地址**********')
        console.log('res: ', res.data)
        this.getUserLocation(res.data)
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 获取UserLocation
     */
    async getUserLocation (ipAddr) {
      console.log('getUserLocation ...')
      try {
        const res = await this.axios.get('2/json/' + ipAddr)
        console.log('ip国家地址详情**********')
        console.log('res: ', res.data)
        this.ipGeo = res.data
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 获取列表
     */
    getDecomposList () {
      console.log('getDecomposList userID:', this.userID)
      const data = this.axios.get('/getDecomposListByPage', {
        params: {
          userID: this.userID,
          ...this.listQuery
        }
      })
      data.then(res => {
        if (res.code === '405') {
          this.$router.push('/405')
          return
        }
        if (res.data.length === 0) {
          this.tableData = []
        } else {
          this.tableData = res.data.list
          this.total = res.data.total
          console.log('getDecomposList:', res.data.list)
        }
      })
    },
    goDetailwithType (id, fileClass, name, fileName) {
      let routeUrl = ''
      if (fileClass === '.fastq') {
        routeUrl = '/detail_krona?key='
      }
      if (fileClass === '.fasta') {
        routeUrl = '/detail_dist?key='
      }
      let key = JSON.stringify({
        userid: this.userID,
        procid: id,
        name: name,
        fileClass: fileClass,
        fileName,
        goback: 0
      })
      routeUrl += key
      routeUrl = this.$router.resolve(routeUrl)
      console.log('detail key: ', key)
      let url = this.globalUrl + '/dist/' + routeUrl.href
      console.log('detail url: ', url)
      url = encodeURIComponent(url)
      console.log('qiime encodeURIComponent url: ', url)
      this.axios({
        url: '/kssd/openurl',
        method: 'post',
        data: { url: url }
      }).then(res => {
        console.log('res:', res)
      })
    },
    goBatchDetail (batchid, barplotid, heatmapid) {
      console.log('goBatchDetail batchid,barplotid,heatmapid:', batchid, barplotid, heatmapid)
      let key = JSON.stringify({
        userid: this.userID,
        barplotid: barplotid,
        heatmapid: heatmapid,
        goback: 0
      })
      console.log('qiime key: ', key)
      let routeUrl = '/detail_qiime?key=' + key
      console.log('qiime routeUrl: ', routeUrl)
      routeUrl = this.$router.resolve(routeUrl)
      console.log('qiime resolve routeUrl: ', routeUrl)
      let url = this.globalUrl + '/dist/' + routeUrl.href
      console.log('qiime url: ', url)
      url = encodeURIComponent(url)
      console.log('qiime encodeURIComponent url: ', url)
      this.axios({
        url: '/kssd/openurl',
        method: 'post',
        data: { url: url }
      }).then(res => {
        console.log('res:', res)
      })
      // window.open(url)
      // this.$router.push('/detail_qiime?userid=' + this.userID + '&barplotid=' + barplotid + '&heatmapid=' + heatmapid)
    },
    goDownloadClient () {
      this.$router.push('/DownloadClient')
    },
    /**
     * 文件选择
     */
    SelectFile () {
      // 非windows使用网页打开方式
      if (getOSName() !== 'Windows' || this.form.selectFileWithWeb) {
        this.$refs.uploadDialog.handle(this.files)
        return
      }
      const data = this.axios.get('/kssd/selectFile')
      data.then(res => {
        console.log('res.data.files.length = ', res.data.files.length)
        if (res.data.files.length === 0) {
          return
        }
        this.checkSelectFile(res.data.files)
      })
    },
    checkSelectFile (files) {
      for (let i = 0, len = files.length; i < len; i++) {
        const fileItem = files[i]
        console.log(files[i].file)
        if (this.checkFileName(fileItem.file) === false) {
          this.$message.error('The path or name of file contains characters that are not allowed.')
          continue
        }
        // 与列表对比，如果存在文件名一样的，忽略
        let find = false
        for (let n = 0, len = this.tableData.length; n < len; n++) {
          if (this.tableData[n].FileName === fileItem.name) {
            find = true
            this.$message.error('The selected file name has been processed.')
            console.log('here have same file.', this.tableData[n].SelectFile, i)
            break
          }
        }
        if (find === true) {
          continue
        }
        // 更新重复的
        find = false
        for (let n = 0, len = this.files.length; n < len; n++) {
          if (this.files[n].file === fileItem.file) {
            this.files[n] = fileItem
            find = true
            break
          }
        }
        if (find !== true) {
          if (this.files.length >= this.form.maxSelectMultipleFileNum) {
            this.$message.error('The selected files too many, ignore some.')
          } else {
            this.files.push(fileItem)
          }
        }
      }
      console.log('this.files len:', this.files.length)
      console.log('this.files:', this.files)
    },
    /**
     * 文件提交
     */
    toSubmit () {
      this.isSubmiting = true
      for (let i = 0; i < this.form.threadnum; i++) {
        this.uploadProcNetwork()
      }
    },
    FindFreeFiles () {
      for (let n = 0, len = this.files.length; n < len; n++) {
        if (this.files[n].state === 0) {
          this.files[n].state = 1
          return n
        }
      }
      this.CancelBtName = 'Close'
      return -1
    },
    uploadProcNetwork () {
      let idx = this.FindFreeFiles()
      if (idx === -1) {
        console.log('all files is proced.')
        return
      }
      let name = this.files[idx].name
      const data = this.axios.post('/kssd/uploadProc', JSON.stringify({
        selectFile: this.files[idx].file,
        shufFile: '',
        OSName: this.OSName
      }))
      data.then(res => {
        console.log('uploadProc res.data.procID:', name, res.data.procID)
        this.getStatus(res.data.procID, name)
      })
    },
    GetIdxByName (name) {
      for (let n = 0, len = this.files.length; n < len; n++) {
        if (this.files[n].name === name) {
          return n
        }
      }
      console.log('GetIdxByName=-1: ', name)
      return -1
    },
    /**
     * 定时调用接口查看状态 超时时间15分钟
     */
    getStatus (procID, name) {
      console.log('getStatus name: ', name)
      if (!this.isSubmiting) { // 非提交状态返回
        return
      }
      let idx = this.GetIdxByName(name)
      if (idx === -1) {
        // debugger
        return
      }
      setTimeout(() => {
        const data = this.axios.post('/kssd/queryFile', {
          procID: procID
        })
        data.then(res => {
          console.log(res)
          const state = Number(res.data.state)
          console.log('name,state:', name, state)
          idx = this.GetIdxByName(name)
          if (idx === -1) {
            return
          }
          this.files[idx].state = state
          this.files[idx].showMsg = res.data.showMsg
          if (state < 0) {
            this.uploadProcNetwork()
            return
          }
          // 判断条件，不满足结果继续执行
          if (state === 9) {
            this.uploadProcNetwork()
            this.files.splice(idx, 1)
            console.log('getStatus files.splice:', idx, name)
            if (this.files.length === 0) {
              this.isSubmiting = false
              this.CancelBtName = 'Cancel'
            }
            this.getDecomposList()
            return
          }
          if (state !== 9 && state > 0) {
            console.log('getStatus state:', state)
            this.getStatus(procID, name)
          }
        })
      }, 500)
    },
    DeleteRecord () {
      console.log('DeleteRecord...')
      let tipsNode = ''
      this.selectionData.forEach(item => {
        tipsNode += `<div>Sample file:${item.Name}</div>`
      })
      tipsNode = `<div>${tipsNode}</div>`
      this.$confirm('This operation will delete the following files, are you sure?' + tipsNode, 'Confirm', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'Sure',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        let list = ''
        const loading = this.$loading({
          lock: true,
          text: 'wait a moment ...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.selectionData.forEach(item => {
          console.log('item:', item)
          list += 'arrProcID=' + item.ProcID + '&'
        })
        let url = '/kssd/deldecom'
        const data = this.axios({
          method: 'post',
          url: url,
          data: list,
          headers: {
            UserID: this.userID
          }
        })
        data.then(res => {
          loading.close()
          console.log('res.data:', res.data)
          console.log('res.data.retCode:', res.data.retCode)
          if (res.data.retCode === 0) {
            this.$message.success('success')
            this.getDecomposList()
          } else {
            this.$message.error('fail\n' + res.data.retMsg)
          }
        })
      })
    },
    Detail (index, row) {
      console.log(index, row)
      this.goDetailwithType(row.ProcID, row.FileClass, row.Name, row.FileName)
    },
    Batch_qiime () {
      let list = ''
      const loading = this.$loading({
        lock: true,
        text: 'wait a moment ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.selectionData.forEach(item => {
        list += 'ProcID=' + item.ProcID + '&' + 'Name=' + item.Name + '&'
      })
      let url = '/kssd/batch_qiime'
      const data = this.axios({
        method: 'post',
        url: url,
        data: list,
        headers: {
          UserID: this.userID
        }
      })
      data.then(res => {
        loading.close()
        console.log('batch_qiime res.data:', res.data)
        let retCode = res.data.retCode
        let batchid = res.data.batchid || ''
        let barplotid = res.data.barplotid || ''
        let heatmapid = res.data.heatmapid || ''
        if (retCode < 0) {
          let retMsg = res.data.retMsg
          console.log('retMsg:', retMsg)
          this.$message.error('fail\n' + retMsg)
        } else {
          this.goBatchDetail(batchid, barplotid, heatmapid)
        }
      }).catch(() => {
        loading.close()
      })
    },
    toCancel () {
      this.isSubmiting = false
      this.files = []
      this.CancelBtName = 'Cancel'
      this.getDecomposList()
    },
    Switch_view () {
      this.isCardListView = !this.isCardListView
      // this.$refs.multipleTable.toggleRowSelection(this.tableData[2], true)
      if (!this.isCardListView) {
        this.selectedIdxs.forEach(index => {
          this.$refs.multipleTable.toggleRowSelection(this.tableData[index])
        })
      }
    },
    selectClick (index) {
      console.log('selectClick')
      console.log(index)
      const idxPostion = this.selectedIdxs.indexOf(index)
      if (idxPostion === -1) {
        this.selectedIdxs.push(index)
      } else {
        this.selectedIdxs.splice(idxPostion, 1)
      }
    },
    getLabelsConfig () {
      const data = this.axios.get('/getLabelsConfig')
      data.then(res => {
        if (res.data.retCode === 0) {
          this.sysLabels = res.data.data
        }
      })
    },
    // #region *******************表格选中******************************** *//
    tableSelect (selection, row) {
      console.log('tableSelect')
      console.log(selection)
      console.log(row)
      const index = row.index
      const idxPostion = this.selectedIdxs.indexOf(index)
      if (idxPostion === -1) {
        this.selectedIdxs.push(index)
      } else {
        this.selectedIdxs.splice(idxPostion, 1)
      }
    },
    tableSelectAll (selection, row) {
      if (selection.length === 0) {
        this.selectedIdxs = []
      } else {
        this.selectedIdxs = this.tableData.map(item => item.index)
      }
    },
    // 把每一行的索引放进row
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    getTableLabels (CustomLabels) {
      try {
        const lables = JSON.parse(CustomLabels)
        return lables.join(',')
      } catch (error) {
        return ''
      }
    },
    getTableSystemLabels (SystemLabels) {
      try {
        const attributes = JSON.parse(SystemLabels)
        let attributesStr = ''
        const keys = Object.keys(attributes)
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          attributesStr += (key + ':' + attributes[key] + ';')
        }
        return attributesStr
      } catch (error) {
        return ''
      }
    },
    catchTap (e) {
      e.stopPropagation()
      e.preventDefault()
    },
    // #endregion *******************表格选中******************************** *//

    // #region *******************编辑Labels******************************** *//
    editLabels (row, flag = -1) {
      this.$nextTick(() => {
        this.$refs.dialog.handle(row, flag)
      })
    },
    // #endregion *******************编辑Labels******************************** *//
    // #region *******************筛选、搜索******************************** *//
    handleFilter () {
      this.listQuery.page = 1
      this.listQuery.keyword = ''
      this.getDecomposList()
    },
    // 搜索
    handleSearch () {
      this.getDecomposList()
    },
    // #endregion *******************筛选、搜索******************************** *//

    // #region *******************获取缩略图全地址******************************** *//
    getImgUrl (baseUrl) {
      // "../outFiles/b2c8429b04ce1d9e8b493334015bae9c/202304232033357276137275594/imgfile/screenshot.png"
      return baseUrl.replace('../outFiles', this.globalUrl + '/image')
    },
    // #endregion *******************获取缩略图全地址******************************** *//

    // #region *******************上传文件******************************** *//
    handleMessage (event) {
      // 接收消息
      // if (event.origin !== 'http://localhost:8080') return // 确定消息来源
      const message = event.data
      if (message.kssdFiles) {
        console.log('Received message from iframe: ', message.kssdFiles)
        this.$refs.uploadDialog.receivedMsg(message.kssdFiles)
        // 发送消息
        // this.$refs.uploadDialog.sendMsg('hello kssd')
      } else if (message.kssdPath) {
        console.log('Received kssdPath from iframe: ', message.kssdPath)
        this.$refs.uploadDialog.receivedIframePathMsg(message.kssdPath)
      }
    },
    updateSelectedFilesList (files) {
      this.files = []
      this.checkSelectFile(files)
    },
    // #endregion *******************上传文件******************************** *//
    // #region *******************检查路径是否正确******************************** *//
    getWorkPath () {
      const data = this.axios.get('/kssd/getWorkPath')
      data.then(res => {
        if (res.data.retCode === 0) {
          const dir = res.data.dir
          this.containsSpecialChar = !this.checkFileName(dir)
        }
      })
    }
    // #endregion *******************检查路径是否正确******************************** *//

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.navbar {
  position: relative;
  min-height: 50px;
  border-radius: 0px;
  box-shadow: rgb(153 153 153) 0px 1px 5px;
  z-index: 1;
  border: 0px;
  margin-bottom: 21px;
  padding: 0 60px;
}
.file-list {
}
.upload-scroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.upload-body {
  flex: 1;
  max-width: 1170px;
  margin: auto;
  width: 100%;
  min-height: 1px;
  text-align: left;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.title {
  font-size: 18px;
}
.upload-file {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: auto;
  margin: 15px 0px 10px;
  border-style: dashed;
  border-radius: 5px;
  border-width: medium;
  border-color: rgb(153, 153, 153);
  color: rgb(153, 153, 153);
  cursor: pointer;
  background-color: rgb(248, 248, 248);
  box-shadow: rgb(153 153 153) 5px 5px 5px;
  position: relative;
}
.del {
  position: absolute;
  right: 0;
  top: 0;
  color: rgb(228, 120 ,70);
}
.upload-state {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.upload-files-show {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  margin: 15px 0px 10px;
  color: rgb(153, 153, 153);
  cursor: pointer;
  background-color: white;
  /* background-color: rgb(248, 248, 248); */
  /* box-shadow: rgb(153 153 153) 5px 5px 5px; */
  position: relative;
  z-index: 1000;
}

.show-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-height: 730px;
}

.show-list.scroll {
  overflow: scroll;
  overflow-x: hidden;
}

.show-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  position: relative;
  padding: 12px;
  border-radius: 8px;
}

.item-right {
  margin-left: 10px;
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mask {
  position: fixed;
  z-index: 900;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

/* 文本超过一行显示省略号 */
.ellipse-line-one {
  overflow: hidden;
  /*不换行*/
  white-space: nowrap;
  /*超出部分文字以...显示*/
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.item-name {
  width: 100%;
}

.submit-btns {
  background-color: #f8f8f8;
}

.error {
  color: red;
}

/* #region*******************卡片列表******************************** */
.card-list {
  width: 100%;
}

.card-item {
  border-radius: 4px;
  border: 1px solid #EBEEF5;
  background-color: #FFF;
  overflow: hidden;
  color: #303133;
  -webkit-transition: .3s;
  transition: .3s;

  position: relative;
  margin-bottom: 20px;
  width: 32%;
  height: 480px;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.card-title {
  width: 100%;
  box-sizing: border-box;
}

.card-big-title {
  font-weight: bold;
}

.card-detail {
  width: 100%;
  overflow: hidden;
}

.card-item:not(:nth-child(3n+1)) {
    margin-left: 2%;
}
/* .card-item:nth-child(3n+1) {
    margin-left: 2%;
}

.card-item:nth-child(3n+2) {
    margin-left: 2%;
} */

.card-item.selected {
  background-color: rgb(234, 255, 255);
  border: 1px solid #409EFF;
}
.card-img {
  margin-bottom: 10px;
  width: 100%;
  height: 240px;
}

.image-slot {
  width: 100%;
  height: 100%;
  }

.screen-shot-tips {
  width: 100%;
  height: 100%;
  color: #c0c4cc;
  background: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  font-size: 14px;
}

.card-btns {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.card-item-edit {
  position: absolute;
  right: 20px;
  width:10px;
  height:10px;
}
/* #endregion*******************卡片列表******************************** */

</style>



// WEBPACK FOOTER //
// src/components/index.vue